"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = Checkbox;
exports.CheckboxGroup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    border: solid ", "px ", ";\n    transition: .5s all;\n    border-radius: ", "px;\n    background-color: ", ";\n    background-image: ", ";\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    display: block;\n    transform-style: preserve-3d;\n    -webkit-appearance: none;\n    float: ", ";\n    width: ", "px;\n    height: ", "px;\n    margin: 0 ", "px 0 ", "px;\n    cursor: inherit\n    :focus {\n        outline: none;\n    }\n\n    &:hover::before {\n        left: -", "px;\n        top: -", "px;\n        content: \"\";\n        position: absolute;\n        background-color: ", ";\n        border-radius: ", "px;\n        width: ", "px;\n        height: ", "px;\n        transform: translateZ(-1px);\n    }\n    &:active::before {\n        left: -", "px;\n        top: -", "px;\n        content: \"\";\n        position: absolute;\n        background-color: ", ";\n        border-radius: ", "px;\n        width: ", "px;\n        height: ", "px;\n        transform: translateZ(-1px);\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    opacity: ", ";\n    transition: .5s opacity;\n    position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    transition: .5s opacity;\n    line-height: ", "px;\n    display: ", ";\n    position: relative;\n    font-size: ", "rem;   \n    font-family: ", "; \n    padding: ", "px 0px;\n    cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SwitchWrapper = _styledComponents["default"].label(_templateObject(), function (props) {
  return props.disabled ? props.colorObj.disabledColor : props.colorObj.textColor;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.label ? 'block' : 'inline';
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
});

var InputGroupWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.disabled ? '.5' : '1';
});

var CheckBoxInputWrapper = _styledComponents["default"].input(_templateObject3(), function (props) {
  return props.spacingObj.borderWidth;
}, function (props) {
  return props.disabled ? props.colorObj.disabledColor : props.checked ? props.colorObj.fillColor : props.colorObj.borderColor;
}, function (props) {
  return props.spacingObj.borderRadius;
}, function (props) {
  return props.disabled ? props.colorObj.disabledColor : props.checked ? props.colorObj.fillColor : props.colorObj.fillColorSecondary;
}, function (props) {
  return props.partiallySelected ? props.colorObj.minusImage(props.colorObj.fillCheckColor) : props.checked ? props.colorObj.checkImage(props.colorObj.fillCheckColor) : 'none';
}, function (props) {
  return props.align;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.spacingObj.margin * 3;
}, function (props) {
  return props.spacingObj.margin;
}, function (props) {
  return props.spacingObj.width / 2 + 2;
}, function (props) {
  return props.spacingObj.height / 2 + 2;
}, function (props) {
  return props.disabled ? 'none' : props.checked ? props.colorObj.checkedHoverColor : props.colorObj.hoverColor;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.spacingObj.width * 2;
}, function (props) {
  return props.spacingObj.height * 2;
}, function (props) {
  return props.spacingObj.width / 2 + 2;
}, function (props) {
  return props.spacingObj.height / 2 + 2;
}, function (props) {
  return props.disabled ? 'none' : props.checked ? props.colorObj.checkedActiveColor : props.colorObj.activeColor;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.spacingObj.width * 2;
}, function (props) {
  return props.spacingObj.height * 2;
});
/**
 * The Checkbox component is used as a toggle for a single option.
 * @example import { Checkbox } from '@desktop/react';
 */


function Checkbox(props) {
  var inherit = "switches";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var colors = context.getColors()[inherit];
  var spacing = context.getSpacing()[inherit];

  var _useState = (0, _react.useState)(props.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  (0, _react.useEffect)(function () {
    setChecked(props.checked || props.partiallySelected);
  }, [props.checked, props.partiallySelected]);

  var updateChecked = function updateChecked() {
    setChecked(!checked);
    props.onChange(!checked, props.value, props);
  };

  return /*#__PURE__*/_react["default"].createElement(SwitchWrapper, {
    disabled: props.disabled,
    colorObj: colors,
    spacingObj: spacing,
    style: props.style,
    fontFamilyObj: context.getFont()
  }, /*#__PURE__*/_react["default"].createElement(CheckBoxInputWrapper, {
    type: "checkbox",
    align: props.align,
    disabled: props.disabled,
    partiallySelected: props.partiallySelected,
    colorObj: colors,
    spacingObj: spacing,
    checked: checked,
    onChange: updateChecked,
    value: props.value
  }), props.label);
}

Checkbox.propTypes = {
  /**Alignment of the CheckBox input in respect to the label text. */
  align: _propTypes["default"].string,

  /**Sets if the CheckBox should be in a checked state or not. */
  checked: _propTypes["default"].bool,

  /**Toggle to enable and disable the CheckBox control. */
  disabled: _propTypes["default"].bool,

  /**Sets the CheckBox to a partially selected state. This will override the checked icon. */
  partiallySelected: _propTypes["default"].bool,

  /**The callback function that is fired when the checkbox's state is changed. */
  onChange: _propTypes["default"].func,

  /**The overriding styling of the CheckBox container. */
  style: _propTypes["default"].object,

  /**The value assigned to this CheckBox, exposed when this input is checked. */
  value: _propTypes["default"].string,

  /**The label of the checkbox */
  label: _propTypes["default"].node
};
Checkbox.defaultProps = {
  align: 'left',
  checked: false,
  disabled: false,
  label: '',
  onChange: function onChange() {
    return false;
  },
  style: {},
  value: '',
  partiallySelected: false,
  className: null
};
/**
 * The CheckboxGroup component is used to select one or more options from a list.
 * Available functions via refs:
 * - getValues(): returns an array of checked values.
 * @example import { CheckboxGroup } from '@desktop/react';
 */

var CheckboxGroup = (0, _react.forwardRef)(function (props, ref) {
  var _useState3 = (0, _react.useState)(resolveChildren()),
      _useState4 = _slicedToArray(_useState3, 2),
      items = _useState4[0],
      setItems = _useState4[1];

  var onChange = props.onChange;
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getValues: getValues
    };
  });

  function resolveChildren() {
    var items = [];
    props.children.map(function (obj) {
      items.push(_objectSpread({
        style: obj.props.style,
        checked: obj.props.defaultChecked,
        value: obj.props.value ? obj.props.value : obj.props.children
      }, obj.props));
    });
    return items;
  }

  function getValues() {
    var values = [];
    items.map(function (item, i) {
      if (item.checked) {
        values.push(item.value);
      }
    });
    return values;
  }

  function updateValue(checked, value, props) {
    if (props.disabled) {
      return false;
    }

    var pos = props["data-itemid"];
    items[pos].checked = !items[pos].checked;
    var vals = getValues();
    onChange(checked, vals, props);
  }

  var itemNodes = [];
  items.map(function (item, i) {
    itemNodes.push( /*#__PURE__*/_react["default"].createElement(Checkbox, {
      key: "label" + i,
      checked: !!item.checked,
      partiallySelected: item.partiallySelected,
      style: item.style,
      "data-itemid": i,
      className: item.className,
      disabled: item.disabled,
      onChange: updateValue,
      value: item.value ? item.value : '',
      label: item.children,
      align: item.align
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(InputGroupWrapper, {
    disabled: props.disabled,
    style: props.style
  }, itemNodes);
});
exports.CheckboxGroup = CheckboxGroup;
CheckboxGroup.defaultProps = {
  style: {},
  disabled: false,
  onChange: function onChange() {
    return false;
  }
};